import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { Ref, computed } from '@vue/composition-api';
import { useAllowlist, useStdObjectiveType, useStdAdgroupIs } from '@tt4b/ttam-hooks';

export function useTargetTypePropsVisible(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData, campaignData } = props;
  const { isConversion, isDpa } = useStdObjectiveType({
    campaignFormData: campaignData,
  });
  const { isHasTikTok, isStandardAdsWithCatalog } = useStdAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });

  /** in-market 定向是否可用 */
  const isInMarketTargetAvailable = computed(
    () => (isConversion.value || isDpa.value || isStandardAdsWithCatalog.value) && isHasTikTok.value
  );
  return {
    visible: isInMarketTargetAvailable,
  };
}
